
import { forkJoin as observableForkJoin, Observable } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CropperSettings, ImageCropperComponent, Bounds } from "ng2-img-cropper";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { HeaderConfigurationResource } from "app/models/HeaderConfigurationResource";
import { HeaderService } from "app/homepage-configuration/header/header.service";
import { ElementRef } from "@angular/core";

@Component({
  selector: 'vbn-header-style-config',
  templateUrl: './header-style-config.component.html',
  styleUrls: ['./header-style-config.component.scss'],
  providers: [HeaderService]
})
export class HeaderStyleConfigComponent implements OnInit {

  //logo
  showButtonImage: boolean = true;
  showCropImage: boolean = false;
  resultImg: boolean = false;
  imageCrt: boolean = true;
  cropperSettings: CropperSettings;
  croppedImg: any;
  isInvalidImgSizeLogo: boolean = false;
  showCropBtnLogo: boolean = true;
  showConfirmation;
  backgroundColor;
  textColor;
  imageError: boolean = false;

  showButtonImageEN: boolean = true;
  showCropImageEN: boolean = false;
  resultImgEN: boolean = false;
  imageCrtEN: boolean = true;
  cropperSettingsEN: CropperSettings;
  croppedImgEN: any;
  isInvalidImgSizeLogoEN: boolean = false;
  showCropBtnLogoEN: boolean = true;
  imageErrorEN: boolean = false;
  imageErrorDE: boolean = false;
  imageErrorFR: boolean = false;
  cropperSettingsFR: CropperSettings;
  cropperSettingsDE: CropperSettings;
  croppedImgFR: any;
  croppedImgDE: any;
  isInvalidImgSizeLogoFR: boolean = false;
  showCropBtnLogoFR: boolean = true;
  isInvalidImgSizeLogoDE: boolean = false;
  showCropBtnLogoDE: boolean = true;
  showButtonImageFR: boolean = true;
  showCropImageFR: boolean = false;
  resultImgFR: boolean = false;
  imageCrtFR: boolean = true;
  showButtonImageDE: boolean = true;
  showCropImageDE: boolean = false;
  resultImgDE: boolean = false;
  imageCrtDE: boolean = true;

  //variables
  dateNow: Date;
  image: any = new Image();
  headerResource: HeaderConfigurationResource;
  errorMessage: any;

  selected_language: string = "ro";



  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  @ViewChild('cropperEN', undefined) cropperEN: ImageCropperComponent;
  @ViewChild('cropperFR', undefined) cropperFR: ImageCropperComponent;
  @ViewChild('cropperDE', undefined) cropperDE: ImageCropperComponent;

  constructor(private translate: TranslateService,
    private _notificationService: NotificationsService,
    private headerService: HeaderService,
    private element: ElementRef) {
    //logo
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.croppedWidth = 400;
    this.cropperSettings.croppedHeight = 200;
    this.cropperSettings.canvasWidth = 400;
    this.cropperSettings.canvasHeight = 200;
    this.cropperSettings.width = 400;
    this.cropperSettings.height = 200;
    this.cropperSettings.keepAspect = true;
    this.croppedImg = {};
    //en
    this.cropperSettingsEN = new CropperSettings();
    this.cropperSettingsEN.croppedWidth = 400;
    this.cropperSettingsEN.croppedHeight = 200;
    this.cropperSettingsEN.canvasWidth = 400;
    this.cropperSettingsEN.canvasHeight = 200;
    this.cropperSettingsEN.width = 400;
    this.cropperSettingsEN.height = 200;
    this.cropperSettingsEN.keepAspect = true;
    this.croppedImgEN = {};
    this.headerResource = new HeaderConfigurationResource();
    //fr
    this.cropperSettingsFR = new CropperSettings();
    this.cropperSettingsFR.croppedWidth = 400;
    this.cropperSettingsFR.croppedHeight = 200;
    this.cropperSettingsFR.canvasWidth = 400;
    this.cropperSettingsFR.canvasHeight = 200;
    this.cropperSettingsFR.width = 400;
    this.cropperSettingsFR.height = 200;
    this.cropperSettingsFR.keepAspect = true;
    this.croppedImgFR = {};
    this.headerResource = new HeaderConfigurationResource();
    //en
    this.cropperSettingsDE = new CropperSettings();
    this.cropperSettingsDE.croppedWidth = 400;
    this.cropperSettingsDE.croppedHeight = 200;
    this.cropperSettingsDE.canvasWidth = 400;
    this.cropperSettingsDE.canvasHeight = 200;
    this.cropperSettingsDE.width = 400;
    this.cropperSettingsDE.height = 200;
    this.cropperSettingsDE.keepAspect = true;
    this.croppedImgDE = {};
    this.headerResource = new HeaderConfigurationResource();
    //other
    this.dateNow = new Date();
  }

  ngOnInit() {
    this.getHeaderConfig();
  }

  //logo
  cropped(bounds: Bounds) {
    //console.log(bounds);
    if (this.isInvalidImgSizeLogo) {
      this.clearLogo();
    }
  }
  croppedEN(bounds: Bounds) {
    //console.log(bounds);
    if (this.isInvalidImgSizeLogoEN) {
      this.clearLogoEN();
    }
  }
  
  croppedDE(bounds: Bounds) {
    //console.log(bounds);
    if (this.isInvalidImgSizeLogoDE) {
      this.clearLogoDE();
    }
  }
  
  croppedFR(bounds: Bounds) {
    //console.log(bounds);
    if (this.isInvalidImgSizeLogoFR) {
      this.clearLogoFR();
    }
  }

  openImageSelect() {
    this.showButtonImage = false;
    this.showCropImage = true;
    this.croppedImg = {};
  }

  cancelImage() {
    this.showCropImage = false;
    this.showButtonImage = true;
  }

  saveImageCropped(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.headerResource.logoImageString = imgCrop;
      this.image.src = "";
      this.showCropImage = false;
      this.imageCrt = false;
      this.resultImg = true;
      this.showButtonImage = true;
      // console.log("---------", this.croppedEditImg)
    }
  }

  clearLogo() {
    this.croppedImg = {};
    this.cropper.reset();
    return;
  }

  openImageSelectEN() {
    this.showButtonImageEN = false;
    this.showCropImageEN = true;
    this.croppedImgEN = {};
  }

  cancelImageEN() {
    this.showCropImageEN = false;
    this.showButtonImageEN = true;
  }

  saveImageCroppedEN(imgCropEN) {
    if (imgCropEN != null && imgCropEN != '') {
      this.headerResource.logoImageEnString = imgCropEN;
      this.image.src = "";
      this.showCropImageEN = false;
      this.imageCrtEN = false;
      this.resultImgEN = true;
      this.showButtonImageEN = true;
      // console.log("---------", this.croppedEditImg)
    }
  }

  clearLogoEN() {
    this.croppedImgEN = {};
    this.cropperEN.reset();
    return;
  }

  openImageSelectFR() {
    this.showButtonImageFR = false;
    this.showCropImageFR = true;
    this.croppedImgFR = {};
  }

  cancelImageFR() {
    this.showCropImageFR = false;
    this.showButtonImageFR = true;
  }

  saveImageCroppedFR(imgCropFR) {
    if (imgCropFR != null && imgCropFR != '') {
      this.headerResource.logoImageFrString = imgCropFR;
      this.image.src = "";
      this.showCropImageFR = false;
      this.imageCrtFR = false;
      this.resultImgFR = true;
      this.showButtonImageFR = true;
      // console.log("---------", this.croppedEditImg)
    }
  }

  clearLogoFR() {
    this.croppedImgFR = {};
    this.cropperFR.reset();
    return;
  }


  clearLogoDE() {
    this.croppedImgDE = {};
    this.cropperDE.reset();
    return;
  }

  openImageSelectDE() {
    this.showButtonImageDE = false;
    this.showCropImageDE = true;
    this.croppedImgDE = {};
  }

  cancelImageDE() {
    this.showCropImageDE = false;
    this.showButtonImageDE = true;
  }

  saveImageCroppedDE(imgCropDE) {
    if (imgCropDE != null && imgCropDE != '') {
      this.headerResource.logoImageDeString = imgCropDE;
      this.image.src = "";
      this.showCropImageDE = false;
      this.imageCrtDE = false;
      this.resultImgDE = true;
      this.showButtonImageDE = true;
      // console.log("---------", this.croppedEditImg)
    }
  }

  checkFile(event) {
    console.log(event)
    let file = event.target.files[0];
    this.isInvalidImgSizeLogo = false;
    this.showCropBtnLogo = true;
    if (file.type == "image/jpeg" || file.type == "image/JPEG" || file.type == "image/jpg" || file.type == "image/JPG"
      || file.type == "image/png" || file.type == "image/PNG" || file.type == "image/gif" || file.type == "image/GIF"
      || file.type == "image/bitmap" || file.type == "image/BITMAP" || file.type == "image/tiff" || file.type == "image/TIFF") {
      if (file.size > 2000000) {
        observableForkJoin(
          this.translate.get('Error'),
          this.translate.get('Maximum size of image is 2 MB!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
        event.target.value = "";
        if (event.currentTarget.id == 1) {
          this.isInvalidImgSizeLogo = true;
          this.showCropBtnLogo = false;
        }
        console.log(event)
        return;
      } else {
        var myReader: FileReader = new FileReader();
        var imageRo = this.element.nativeElement.querySelector('#fileupload');
        var imageEn = this.element.nativeElement.querySelector('#fileuploadEn');
        var imageDe = this.element.nativeElement.querySelector('#fileuploadDe');
        var imageFr = this.element.nativeElement.querySelector('#fileuploadFr');
        myReader.onloadend = (e: any) => {
          if (event.target.id == "poster") {
            imageRo.src = e.target.result;
            this.headerResource.logoImageString = e.target.result;
          } 
          else {
            if (event.target.id == "poster2") {
              imageEn.src = e.target.result;
              this.headerResource.logoImageEnString = e.target.result;
            } else if (event.target.id == "poster4"){
              imageFr.src = e.target.result;
              this.headerResource.logoImageFrString = e.target.result;
            } else {
              imageDe.src = e.target.result;
              this.headerResource.logoImageDeString = e.target.result;
            }
          }
        }
        myReader.readAsDataURL(file);
      }
      console.log()
    } else {
      observableForkJoin(
        this.translate.get('Error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF, TIFF, BITMAP!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return;
    }
  }

  getHeaderConfig() {
    this.headerService.getHeaderStyleConfig('/admin/header/headerConfiguration/getOne')
      .subscribe(
      body => {
        this.headerResource = body;
        var imageRo = this.element.nativeElement.querySelector('#fileupload');
        var imageEn = this.element.nativeElement.querySelector('#fileuploadEn');
        var imageDe = this.element.nativeElement.querySelector('#fileuploadDe');
        var imageFr = this.element.nativeElement.querySelector('#fileuploadFr');
        imageRo.src = '';
        imageEn.src = '';
        imageDe.src = '';
        imageFr.src = '';
      },
      error => this.errorMessage = <any>error)
  }

  saveStyleConfiguration() {
    let semafor = false;
    if (this.headerResource.logoActive) {
      if ((this.headerResource.logoImageString == "" || this.headerResource.logoImageString == null || this.headerResource.logoImageString == undefined)
        && (this.headerResource.logoImage == "" || this.headerResource.logoImage == null || this.headerResource.logoImage == undefined)) {
        this.imageError = true;
        semafor = true;
      } else {
        this.imageError = false;
      }
      if ((this.headerResource.logoImageEnString == "" || this.headerResource.logoImageEnString == null || this.headerResource.logoImageEnString == undefined)
        && (this.headerResource.logoImageEn == "" || this.headerResource.logoImageEn == null || this.headerResource.logoImageEn == undefined)) {
        this.imageErrorEN = true;
        semafor = true;
      } else {
        this.imageErrorEN = false;
      }
      if ((this.headerResource.logoImageDeString == "" || this.headerResource.logoImageDeString == null || this.headerResource.logoImageDeString == undefined)
        && (this.headerResource.logoImageDe == "" || this.headerResource.logoImageDe == null || this.headerResource.logoImageDe == undefined)) {
        this.imageErrorDE = true;
        semafor = true;
      } else {
        this.imageErrorDE = false;
      }
      if ((this.headerResource.logoImageFrString == "" || this.headerResource.logoImageFrString == null || this.headerResource.logoImageFrString == undefined)
        && (this.headerResource.logoImageFr == "" || this.headerResource.logoImageFr == null || this.headerResource.logoImageFr == undefined)) {
        this.imageErrorFR = true;
        semafor = true;
      } else {
        this.imageErrorFR = false;
      }
    }
    if (semafor) {
      return;
    }
    this.headerService.saveHeaderStyleConfig(`/admin/header/headerConfiguration/edit`, this.headerResource)
      .subscribe(
      body => {
        this.headerResource = body;
        this.dateNow = new Date();
        this.resultImg = false;
        this.imageCrt = true;
        this.resultImgEN = false;
        this.imageCrtEN = true;
        var imageRo = this.element.nativeElement.querySelector('#fileupload');
        var imageEn = this.element.nativeElement.querySelector('#fileuploadEn');
        var imageDe = this.element.nativeElement.querySelector('#fileuploadDe');
        var imageFr = this.element.nativeElement.querySelector('#fileuploadFr');
        imageRo.src = '';
        imageEn.src = '';
        imageDe.src = '';
        imageFr.src = '';
        observableForkJoin(
          this.translate.get('Success'),
          this.translate.get('Header body config saved with success!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'success')
        })
        this.getHeaderConfig();
      },
      error => console.error(error))
  }

}
